import React from 'react';
import { boundSetFeedback } from '../../store/actions/feedback.actions';
import { clickToCleanSW } from '../serviceWorker/clickToCleanSW';
import { ButtonWithText } from '../../components/atoms/Buttons/ButtonWithText';

const MESSAGE =
  "Nouveaux contenus disponibles sur l'application ! Merci de cliquer sur le bouton, de fermer l'onglet (ou l'application) et de la redémarrer pour voir les modifications.";

const cycleToUpdate = () =>
  boundSetFeedback({
    message: MESSAGE,
    modal: {
      title: 'Nouveaux contenus disponibles',
      actionButton: (
        <ButtonWithText content={"J'ai compris"} onClick={clickToCleanSW} />
      ),
      onCloseAction: clickToCleanSW
    }
  });

export const modalUpdate = (numeroVersion: string) => {
  boundSetFeedback({
    message: MESSAGE,
    modal: {
      title: 'Nouvelle version disponible: ' + numeroVersion + ' 🎉',
      actionButton: (
        <ButtonWithText
          content={'Recharger la page'}
          onClick={clickToCleanSW}
        />
      )
    }
  });
};
export default cycleToUpdate;
